<ng-template [ngIf]="assetFieldObject.length > 0">
  <ng-template ngFor let-formField [ngForOf]="assetFieldObject">
    <ng-template [ngIf]="!['agency', 'client', 'brand', 'plannedDeletionToggle', 'plannedDeletion'].includes(formField.formFieldName) && !formField.hideDetailsView">
      <div [ngSwitch]="formField['fieldType']">
        <div *ngSwitchCase="'dropdown'" class="input-box">
          <div class="dataset-entry flex row items-start my-2">
            <span class="dataset-entry-label w-2/5 field-label"
              >{{ formField['fieldLabel'] }}
              <sup class="text-[#1212128F] cursor-pointer"><mat-icon [matTooltip]="formField['userInfotext'] ?? formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon></sup>
            </span>
            <div class="dataset-entry-value inline-block w-3/5 pl-2" *ngIf="asset[formField['formFieldName']]">
              <span>{{ asset[formField['formFieldName']] | optionsLabel: formField['options'] }}</span>
            </div>
            <div class="dataset-entry-value inline-block w-3/5 pl-2" *ngIf="!asset[formField['formFieldName']] && asset.customFields">
              <span>{{ asset.customFields[formField['formFieldName']] | optionsLabel: formField['options'] }}</span>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'multiSelectChip'" class="input-box">
          <div class="dataset-entry flex row items-start my-2">
            <span class="dataset-entry-label w-2/5 field-label"
              >{{ formField['fieldLabel'] }}
              <sup class="text-[#1212128F] cursor-pointer"><mat-icon [matTooltip]="formField['userInfotext'] ?? formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon></sup></span
            >
            <div class="dataset-entry-value inline-block w-3/5 pl-2 break-words" *ngIf="asset.customFields">
              <ng-template ngFor let-multiSelectField let-i="index" [ngForOf]="asset.customFields[formField['formFieldName']]">
                <span
                  >{{ (i > 0 ? ', ' : '') + (multiSelectField | optionsLabel: formField.options) }}
                  <ng-container *ngIf="multiSelectField | optionsTooltip: formField.options as tooltip">
                    <sup *ngIf="tooltip?.trim()" class="text-[#1212128F] cursor-pointer">
                      <mat-icon [matTooltip]="tooltip" matTooltipClass="tooltip-list">info</mat-icon>
                    </sup>
                  </ng-container>
                </span>
              </ng-template>
            </div>
          </div>
        </div>
        <div *ngSwitchDefault class="input-box">
          <div class="dataset-entry flex row items-start my-2">
            <span class="dataset-entry-label w-2/5 field-label inline-block truncate"
              >{{ formField['fieldLabel'] }}
              <sup class="text-[#1212128F] cursor-pointer"
                ><mat-icon *ngIf="!formField['infotextExternalLink']" [matTooltip]="formField['userInfotext'] ?? formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon></sup
              ></span
            >
            <div class="dataset-entry-value inline-block w-3/5 pl-2 break-words align-top truncate">
              <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="asset[formField['formFieldName']]">
                <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset[formField['formFieldName']]"></div>
              </div>
              <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="!asset[formField['formFieldName']] && asset.customFields">
                <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset.customFields[formField['formFieldName']]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
  <div class="input-box">
    <div class="dataset-entry flex row items-start my-2">
      <span class="dataset-entry-label w-2/5 field-label" i18n>Created at</span>
      <div class="dataset-entry-value inline-block w-3/5 pl-2" *ngIf="asset['createdAt']">
        <span>{{ asset['createdAt'] | spDateFormat: { isSafe: true, plainDate: true } }}</span>
      </div>
    </div>
  </div>
  <div class="input-box">
    <div class="dataset-entry flex row items-start my-2">
      <span class="dataset-entry-label w-2/5 field-label" i18n>Created by</span>
      <div class="dataset-entry-value inline-block w-3/5 pl-2" *ngIf="asset['createdBy']">
        <span>{{ (valueListsService.lookupUserInfo(asset['createdBy']) | async)?.name }}</span>
      </div>
    </div>
  </div>
</ng-template>
